var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"banner bg-agora"}),_c('div',{staticClass:"mosaic-container"},[_c('div',{staticClass:"mosaic-grid"},_vm._l((_vm.shuffledImages),function(img,index){return _c('img',{key:img.url + index,class:['mosaic-item', 'border-md', img.sizeClass],attrs:{"src":img.url,"alt":img.name,"loading":"lazy"}})}),0)])])
}
var staticRenderFns = []

export { render, staticRenderFns }